"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.32612 -0.000488281C1.05208 -0.000488281 0.0012207 1.04271 0.0012207 2.31651V14.5874C0.0012207 15.0993 0.279975 15.5578 0.725074 15.8163C1.18486 16.0833 1.85086 16.0671 2.27045 15.7189L6.0019 12.6222L9.75754 15.7199C10.1697 16.0598 10.8501 16.068 11.2893 15.784C11.7335 15.5204 12.0006 15.0621 12.0006 14.5377V8.96989C14.2506 8.72142 16.0006 6.81582 16.0006 4.5019C16.0006 2.01914 13.9859 0.00646973 11.5006 0.00646973V-0.000488281H2.32612ZM8.67931 0.999512H2.32612C1.60027 0.999512 1.00122 1.59908 1.00122 2.31651V14.5874C1.00122 14.9244 1.38466 15.0941 1.65565 14.9296L5.6816 11.5885C5.86631 11.4352 6.13389 11.4348 6.31906 11.5875L10.3697 14.9285C10.6561 15.0969 11.0006 14.8595 11.0006 14.5377V8.96989C8.75064 8.72142 7.00061 6.81582 7.00061 4.5019C7.00061 3.0863 7.65559 1.82353 8.67931 0.999512ZM8.00061 4.5019C8.00061 2.57238 9.56666 1.00647 11.5006 1.00647C13.4346 1.00647 15.0006 2.57238 15.0006 4.5019C15.0006 6.43141 13.4346 7.99732 11.5006 7.99732C9.56666 7.99732 8.00061 6.43141 8.00061 4.5019ZM11.5006 1.75415C11.7768 1.75415 12.0006 1.97801 12.0006 2.25415V4.00183H13.7506C14.0268 4.00183 14.2506 4.22569 14.2506 4.50183C14.2506 4.77797 14.0268 5.00183 13.7506 5.00183H12.0006V6.74958C12.0006 7.02572 11.7768 7.24958 11.5006 7.24958C11.2245 7.24958 11.0006 7.02572 11.0006 6.74958V5.00183H9.25061C8.97447 5.00183 8.75061 4.77797 8.75061 4.50183C8.75061 4.22569 8.97447 4.00183 9.25061 4.00183H11.0006V2.25415C11.0006 1.97801 11.2245 1.75415 11.5006 1.75415Z"
}));

exports["default"] = _default;